import { getNbHitsByIndex } from "./get-hits-by-index.js";
function getHitCounts(allSearchResults, indices) {
  const productsHitCount = getNbHitsByIndex(allSearchResults, indices.productsIndex?.name);
  const contentHitCount = getNbHitsByIndex(allSearchResults, indices.contentIndex?.name);
  return {
    productsHitCount,
    contentHitCount,
    totalHitCount: productsHitCount + contentHitCount
  };
}
export {
  getHitCounts
};
//# sourceMappingURL=get-hit-counts.js.map
